// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getMessaging, getToken, onMessage, isSupported} from 'firebase/messaging';
import { PushNotifications } from '@capacitor/push-notifications';
import {isMobilePlatform} from "./init & router/capacitorService";
import {Capacitor} from "@capacitor/core";
import {createBrowserRouter, RouterProvider} from "react-router-dom";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDwZrEvfVtTw8LFfYiQPCV1QPrWXcN7Wqc",
    authDomain: "freshtime-54364.firebaseapp.com",
    projectId: "freshtime-54364",
    storageBucket: "freshtime-54364.firebasestorage.app",
    messagingSenderId: "1085065603157",
    appId: "1:1085065603157:web:e1a23c90cd2fa53da40cdc"
};



const firebase_vapid_key = "BLMqOcwZbk5kdefYolTkAQdD_9nuU06mP7EV__ctAGguZRmp2Q9We1yU4im-aWeVdu9JGywlgV4vRgXNKxNGNrM"

// Pour mobile :
const addListeners = async () => {
    await PushNotifications.addListener('registration', token => {
        console.info('Registration token: ', token.value);
    });

    await PushNotifications.addListener('registrationError', err => {
        console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('Push notification received: ', notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        console.log('Push notification action performed', notification.actionId, notification.inputValue);
        //Utilisé dans initial_request
    });
}
const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');

if (isPushNotificationsAvailable) {
    // Uniquement sur mobile là où il est dispo
    addListeners();
    if (Capacitor.getPlatform() === 'android')
    {
        PushNotifications.createChannel({
            id: "push_notif",
            importance: 4,
            name: "Alertes d'anomalies",
            sound: "push_notif.mp3",
            vibration: true,
        });
        PushNotifications.createChannel({
            id: "push_notif_cycle",
            importance: 4,
            name: "Notifications des cycles",
            sound: "push_notif_cycle.mp3",
            vibration: true,
        });
    }

} else{
    // Uniquement Web
    if (await isSupported()) {
        // Initialize Firebase

        const firebase_app = initializeApp(firebaseConfig);
        navigator.serviceWorker.register('/firebase-messaging-sw.js');
        console.log('intitialised web firebase')
    }

}

export const requestForToken = async () => {
    if (isMobilePlatform())
    { //Android & IOS, on utilise le plugin PUSH natif de capacitor
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
            alert("Un problème est survenue. Assurez vous que n'avez pas bloqué l'autorisation pour les notifications. Vous pouvez aussi  vider le cache de l'application/site web.");
        }

        await PushNotifications.register();
        return null;
    }
    else{ //Web, on utilise le SDK web de Firebase
        if (await isSupported()) {
            const messaging = getMessaging();
            return getToken(messaging, {vapidKey: firebase_vapid_key})
                .then((currentToken) => {
                    if (currentToken === undefined) {
                        alert("Un problème est survenue. Assurez vous que n'avez pas bloqué l'autorisation pour les notifications. Vous pouvez aussi  vider le cache de l'application/site web.");
                    }else{
                        if (currentToken) {
                            console.log('current token for client: ', currentToken);
                            return currentToken;
                            // Perform any other neccessary action with the token
                        } else {
                            // Show permission request UI
                            console.log('No registration token available. Request permission to generate one.');
                            return null;
                        }
                    }

                })
                .catch((err) => {
                    console.log('An error occurred while retrieving token. ', err);
                    return null
                });
        } else {
            console.log('Firebase is not supported');
            return null;
        }
    }



};

export const onMessageListener = async (callback: (payload: any) => void) => {
    // Fait dans initital_requests (services > init & router > initital_requests.tsx


    // if (await isSupported()) {
    //     const messaging = getMessaging();
    //     console.log("messaging in messaging");
    //     onMessage(messaging, (payload) => {
    //         console.log("Received message payload:", payload);
    //         callback(payload); // Execute the callback with the message payload
    //     });
    // } else {
    //     console.warn("Messaging is not supported on this browser.");
    // }
};

export const checkExistingToken = async () => {
    if (isMobilePlatform())
    { //Android & IOS, on utilise le plugin PUSH natif de capacitor
        let permStatus = await PushNotifications.checkPermissions();

        return permStatus.receive;


    }
    else { //Web, on utilise le SDK web de Firebase
        if (await isSupported()) {
            try {
                const permission = Notification.permission;
                if (permission === "granted") {
                    const messaging = getMessaging();
                    const token = await getToken(messaging, {vapidKey: firebase_vapid_key});
                    if (token) {
                        console.log('Existing FCM Token:', token);
                        return token
                        // Compare this token with the one stored in your backend
                    } else {
                        console.log('No existing FCM token found.');
                        return null;
                    }
                } else if (permission === "denied") {
                    return "denied";
                } else {
                    return null;
                }
            } catch (error) {
                console.error('Error retrieving FCM token:', error);
            }
        }
    }


};